import { HierarchyUtils, TransformUtils } from '@inter-ikea-core/core';
import { EntityApi, PartKey, ProductType } from '@inter-ikea-storageone/range';
import { duplicateEntity } from '@inter-ikea-storagetwo/range/dist/functions/duplicateEntity';
import SectionComponent from '@inter-ikea-storagetwo/range/dist/components/SectionComponent';
import LeftSideAttachedToComponent from '@inter-ikea-storagetwo/range/dist/components/LeftSideAttachedToComponent';
import RightSideAttachedToComponent from '@inter-ikea-storagetwo/range/dist/components/RightSideAttachedToComponent';
import RemovedLeftSideUnitComponent from '@inter-ikea-storagetwo/range/dist/components/RemovedLeftSideUnitComponent';
import RemovedRightSideUnitComponent from '@inter-ikea-storagetwo/range/dist/components/RemovedRightSideUnitComponent';
export class IvarEntityApi extends EntityApi {
    /**
     * @override
     */
    getOuterMeasurementEntitiesPerWall() {
        const measurementEntitiesPerWall = super.getOuterMeasurementEntitiesPerWall();
        if (!measurementEntitiesPerWall)
            return null;
        // Corner posts in IVAR needs to be handled separately since they should be included in measurements on both walls of the corner
        const cornerPosts = this.getByProductType(ProductType.IVAR_CORNER_POST);
        cornerPosts.forEach(post => {
            const position = TransformUtils.worldTransform(post).position;
            if (position.X < 0 && position.Z < 50) {
                // Post is in left front corner. Add to both of those walls
                measurementEntitiesPerWall['front'].push(post);
                measurementEntitiesPerWall['left'].push(post);
            }
            else if (position.X < 0 && position.Z > 50) {
                // Post is in left back corner. Add to both of those walls
                measurementEntitiesPerWall['back'].push(post);
                measurementEntitiesPerWall['left'].push(post);
            }
            else if (position.X > 0 && position.Z > 50) {
                // Post is in right back corner. Add to both of those walls
                measurementEntitiesPerWall['back'].push(post);
                measurementEntitiesPerWall['right'].push(post);
            }
            else if (position.X > 0 && position.Z < 50) {
                // Post is in right front corner. Add to both of those walls
                measurementEntitiesPerWall['front'].push(post);
                measurementEntitiesPerWall['right'].push(post);
            }
        });
        return measurementEntitiesPerWall;
    }
    /**
     * @override Use duplicate function from storage two package
     */
    duplicate() {
        return duplicateEntity(this.core, this.placementService);
    }
    /**
     * @override handle sections where side units has been removed/merged
     */
    getObjectIdsByEntity(entity) {
        const includedObjectIds = super.getObjectIdsByEntity(entity);
        if (entity.hasComponent(SectionComponent.id)) {
            const removedSideUnitObjectIds = [];
            if (entity.hasComponent(RemovedLeftSideUnitComponent.id)) {
                // Left side unit has been removed from this section. Find merged side unit from neighbor section
                const leftAttachedSection = entity.getComponent(LeftSideAttachedToComponent.id)?.attachedTo;
                const mergedLeftSideUnit = leftAttachedSection &&
                    this.findEntityWithPartKey(HierarchyUtils.children(leftAttachedSection), PartKey.SIDE_UNIT_RIGHT);
                const leftSideObjectIds = mergedLeftSideUnit
                    ? super.getObjectIdsByEntity(mergedLeftSideUnit)
                    : [];
                removedSideUnitObjectIds.push(...leftSideObjectIds);
            }
            if (entity.hasComponent(RemovedRightSideUnitComponent.id)) {
                // Right side unit has been removed from this section. Find merged side unit from neighbor section
                const rightAttachedSection = entity.getComponent(RightSideAttachedToComponent.id)?.attachedTo;
                const mergedRightSideUnit = rightAttachedSection &&
                    this.findEntityWithPartKey(HierarchyUtils.children(rightAttachedSection), PartKey.SIDE_UNIT_LEFT);
                const rightSideObjectIds = mergedRightSideUnit
                    ? super.getObjectIdsByEntity(mergedRightSideUnit)
                    : [];
                removedSideUnitObjectIds.push(...rightSideObjectIds);
            }
            return [...includedObjectIds, ...removedSideUnitObjectIds];
        }
        return includedObjectIds;
    }
}
//# sourceMappingURL=IvarEntityApi.js.map